import React from "react";
import { useTranslation } from "react-i18next";
import { Download } from "lucide-react";

// Per-language whitepaper files (EN, RO provided).
export const WHITEPAPERS = {
    en: "/whitepapers/AIMA_Whitepaper_EN.pdf",
    ro: "/whitepapers/AIMA_Whitepaper_RO.pdf",
};

const SIZES = {
    lg: "h-14 px-7 text-sm",
    md: "h-12 px-6 text-sm",
};

export const WhitepaperButton = ({ testId = "whitepaper-button", size = "lg" }) => {
    const { t, i18n } = useTranslation();
    const lang = (i18n.language || "en").slice(0, 2);
    const file = WHITEPAPERS[lang] || null;
    const base = SIZES[size] || SIZES.lg;

    if (file) {
        return (
            <a
                href={file}
                download
                target="_blank"
                rel="noopener noreferrer"
                data-testid={testId}
                className={`group inline-flex items-center gap-3 ${base} font-plex font-medium transition-all
                    border border-white/15 hover:border-white/40 text-white bg-black/10 backdrop-blur-sm
                    lg:border-cyan/60 lg:bg-graphite lg:text-cyan lg:text-lg lg:font-semibold lg:tracking-tight
                    lg:hover:bg-cyan/[0.08] lg:hover:border-cyan lg:hover:shadow-[0_0_28px_-6px_rgba(0,229,255,0.55)]`}
            >
                {t("whitepaper.download")}
                <Download className="w-4 h-4 lg:w-5 lg:h-5 transition-transform group-hover:translate-y-0.5" strokeWidth={1.7} />
            </a>
        );
    }

    return (
        <div
            data-testid={testId}
            aria-disabled="true"
            className={`inline-flex items-center gap-3 ${base} border border-white/10 text-white/50 font-plex backdrop-blur-sm bg-black/10 cursor-not-allowed select-none`}
            title={t("hero.cta_whitepaper")}
        >
            {t("hero.cta_whitepaper")}
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/35 border-l border-white/10 pl-3">
                {t("hero.coming_soon")}
            </span>
        </div>
    );
};

// Compact text link (footer)
export const WhitepaperLink = () => {
    const { t, i18n } = useTranslation();
    const lang = (i18n.language || "en").slice(0, 2);
    const file = WHITEPAPERS[lang] || null;
    if (file) {
        return (
            <a
                href={file}
                download
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whitepaper-link"
                className="hover:text-white transition-colors"
            >
                {t("whitepaper.download")}
            </a>
        );
    }
    return <span className="text-white/35">{t("hero.cta_whitepaper")} · {t("hero.coming_soon")}</span>;
};

export default WhitepaperButton;
